module.exports = __webpack_public_path__ + "static/media/B&TScreenshot6.48795020.png";